<template>
    <div>
        <h1 class="container d-flex justify-content-center" style="margin-top:100px">Welcome</h1>
        <div v-if="store.state.auth.isAuth" class="container mt-4 d-flex justify-content-center">
            <button @click="$router.push({name: 'Dashboard'})" class="btn btn-primary">Dashboard</button>
        </div>
        <div v-else class="container mt-4 d-flex justify-content-center">
            <button @click="$router.push({name: 'Login'})" class="btn btn-primary">Login</button>
            &nbsp;&nbsp;&nbsp;
            <button @click="$router.push({name: 'Register'})" class="btn btn-primary">Register</button>
        </div>
    </div>
</template>

<script>
import { inject } from 'vue'

export default {
    name: 'Home',
    setup: () => {

        const store = inject('store')

        return { store }
    }
}
</script>
